export const pendingEditProfileListState = {
    isLoading: false,
    pendingEditProfileList: [],
    errorNumber: 0,
    errorMessage: '',
     regionList:[],
    messageLabel: ''
}